import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { customerSlice } from './slices/customerSlice';
import { siteSlice } from './slices/siteSlice';
import { vehicleSlice } from './slices/vehicleSlice';

const rootReducer = combineReducers({
    customer: customerSlice.reducer,
    site: siteSlice.reducer,
    vehicles: vehicleSlice.reducer
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState
    });

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof setupStore>;
